import React from 'react';

import { Alert, Autocomplete, Box, CircularProgress, Stack, TextField } from '@mui/material';

import { errMsg } from './utils';

interface Props {
  chainOptions: Array<string>;
  selectedChain: string | null;
  onChainChange: (chainName: string | null) => void;
  isChainsLoading: boolean;
  isChainsError: boolean;
  chainsError: unknown;
  regionOptions: Array<string>;
  region: string | null;
  onRegionChange: (region: string | null) => void;
}

export default function ChainAndRegionPicker({
  chainOptions,
  selectedChain,
  onChainChange,
  isChainsLoading,
  isChainsError,
  chainsError,
  regionOptions,
  region,
  onRegionChange,
}: Props) {
  return (
    <Box sx={{ mb: 3 }}>
      <Stack direction={{ xs: 'column', md: 'row' }} spacing={2} alignItems={{ md: 'center' }}>
        <Autocomplete<string>
          options={chainOptions}
          value={selectedChain}
          onChange={(_, value) => onChainChange(value)}
          loading={isChainsLoading}
          sx={{ minWidth: 320, flex: 1, maxWidth: 560 }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Hotel chain"
              size="small"
              placeholder="Search chains…"
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <>
                    {isChainsLoading ? <CircularProgress size={16} /> : null}
                    {params.InputProps.endAdornment}
                  </>
                ),
              }}
            />
          )}
        />

        <Autocomplete<string>
          options={regionOptions}
          value={region}
          onChange={(_, value) => onRegionChange(value)}
          sx={{ minWidth: 200 }}
          renderInput={(params) => <TextField {...params} label="Region" size="small" placeholder="All regions" />}
        />
      </Stack>

      {isChainsError && (
        <Alert severity="error" sx={{ mt: 2 }}>
          Failed to load chains: {errMsg(chainsError)}
        </Alert>
      )}
    </Box>
  );
}
